import { Card } from "@/components/ui/card";
import { Lock, FileCheck, Eye, Server } from "lucide-react";

const trustIndicators = [
  {
    icon: Lock,
    title: "Enterprise Security",
    description: "AES-256 encryption, TLS 1.3, and multi-factor authentication protecting your sensitive data.",
  },
  {
    icon: FileCheck,
    title: "Full GDPR Compliance",
    description: "Complete data subject rights, consent management, and privacy-by-design architecture.",
  },
  {
    icon: Eye,
    title: "Progressive Disclosure",
    description: "You control when and how your criminal record information is shared with potential employers.",
  },
  {
    icon: Server,
    title: "99.9% Uptime SLA",
    description: "Enterprise-grade infrastructure ensuring the platform is always available when you need it.",
  },
];

export const TrustSection = () => {
  return (
    <section className="py-32 bg-gradient-to-br from-primary/5 via-accent/5 to-background relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_hsl(var(--primary)/0.08),transparent_60%)]" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-20 space-y-6">
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-primary/10 backdrop-blur-sm rounded-full text-primary font-semibold border border-primary/20 mb-4">
            <Lock className="w-5 h-5 text-accent" />
            <span>Enterprise-Grade Security</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold leading-tight">
            Your Privacy & Security is <span className="text-accent">Guaranteed</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Built with the highest standards of security and compliance to protect your most sensitive information.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {trustIndicators.map((indicator, index) => (
            <Card key={index} className="p-8 text-center hover:shadow-[var(--shadow-elevated)] transition-all duration-300 hover:-translate-y-1 border-2 hover:border-accent/30 bg-card/80 backdrop-blur-sm group">
              <div className="flex justify-center mb-6">
                <div className="p-4 rounded-2xl bg-accent/10 group-hover:scale-110 transition-transform group-hover:bg-accent/15">
                  <indicator.icon className="w-10 h-10 text-accent" />
                </div>
              </div>
              <h3 className="text-lg font-bold mb-3">{indicator.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{indicator.description}</p>
            </Card>
          ))}
        </div>

        <div className="mt-16 p-8 bg-gradient-to-br from-accent/5 to-primary/5 backdrop-blur-sm rounded-2xl max-w-4xl mx-auto border-2 border-accent/20 shadow-[var(--shadow-elevated)]">
          <p className="text-base text-center text-muted-foreground leading-relaxed">
            <strong className="text-foreground font-bold">ROA Compliant:</strong> Our platform follows the Rehabilitation of Offenders Act 1974, 
            ensuring spent convictions are handled appropriately and your rights are protected throughout the hiring process.
          </p>
        </div>
      </div>
    </section>
  );
};
